import { Form } from "react-bootstrap";
import "../style/style-form-cv.css";

export default function FormExperience(props) {
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1980 + 1 },
    (_, index) => currentYear - index
  );

  return (
    <>
      {props.experiences.map((experience, index) => (
        <div className="row" style={{ textAlign: "start" }} key={index}>
          {index > 0 ? (
            <div className="col-12" style={{ marginTop: "10px" }}>
              <p
                href="#"
                style={{ fontWeight: "700", color: "red", textAlign: "end" }}
                onClick={() => props.onSupprimerExperience(index)}
              >
                X
              </p>
            </div>
          ) : null}

          <div className="col-12" style={{ display: "flex" }}>
            <div style={{ width: "33%", paddingRight: "4px" }}>
              <span style={{ fontWeight: "900" }}>Debut</span>

              <div className="row">
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Mois
                  </span>
                  <input
                    type="hidden"
                    className="form-control "
                    name="id_experience[]"
                    value="0"
                  />
                  <Form.Select
                    value={experience.moisDebutExper}
                    onChange={(e) =>
                      props.onChangeExperience(
                        index,
                        "moisDebutExper",
                        e.target.value
                      )
                    }
                    name="mois_debut_exper[]"
                    id=""
                    className="form-control dateDebutExperiance"
                  >
                    <option></option>
                    <option value="01">Janvier</option>
                    <option value="02">Février</option>
                    <option value="03">Mars</option>
                    <option value="04">Avril</option>
                    <option value="05">Mai</option>
                    <option value="06">Juin</option>
                    <option value="07">Juillet</option>
                    <option value="08">Août</option>
                    <option value="09">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                  </Form.Select>
                  {experience.moisDebutExper === "" ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {props.msgErrExperience}
                    </p>
                  ) : null}
                </div>
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Année
                  </span>
                  <Form.Select
                    value={experience.anneeDebutexper}
                    onChange={(e) =>
                      props.onChangeExperience(
                        index,
                        "anneeDebutexper",
                        e.target.value
                      )
                    }
                    className="form-control anneedebutExper"
                  >
                    <option></option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </Form.Select>
                  {experience.anneeDebutexper === "" ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {props.msgErrExperience}
                    </p>
                  ) : null}
                </div>
              </div>
              {experience.anneeFinexper != "" &&
              experience.anneeDebutexper != "" &&
              (experience.anneeFinexper < experience.anneeDebutexper ||
                (experience.anneeFinexper == experience.anneeDebutexper &&
                  experience.moisDebutExper > experience.moisFinExper)) ? (
                <p style={{ fontSize: "12px", color: "red" }}>
                  {props.msgErrDateExper}
                </p>
              ) : null}
            </div>

            <div style={{ width: "33%", paddingRight: "4px" }}>
              <span style={{ fontWeight: "900" }}>Fin</span>
              <div className="row">
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Mois
                  </span>
                  <Form.Select
                    value={experience.moisFinExper}
                    onChange={(e) =>
                      props.onChangeExperience(
                        index,
                        "moisFinExper",
                        e.target.value
                      )
                    }
                    className="form-control datefinExperiance"
                  >
                    <option></option>
                    <option value="01">Janvier</option>
                    <option value="02">Février</option>
                    <option value="03">Mars</option>
                    <option value="04">Avril</option>
                    <option value="05">Mai</option>
                    <option value="06">Juin</option>
                    <option value="07">Juillet</option>
                    <option value="08">Août</option>
                    <option value="09">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                  </Form.Select>
                </div>
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Année
                  </span>
                  <Form.Select
                    value={experience.anneeFinexper}
                    onChange={(e) =>
                      props.onChangeExperience(
                        index,
                        "anneeFinexper",
                        e.target.value
                      )
                    }
                    className="form-control anneedebutExper"
                  >
                    <option></option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>
              {(experience.moisFinExper === "" ||
                experience.anneeFinexper === "") &&
              experience.encoureEper == 0 ? (
                <p style={{ fontSize: "12px", color: "red" }}>
                  {props.msgErreurEncourExper}
                </p>
              ) : null}
            </div>

            <div
              style={{ width: "33%", paddingRight: "2px", textAlign: "center" }}
            >
              <span style={{ fontWeight: "900" }}>En cours</span>
              <div className="row">
                <div className="col-12">
                  <label></label>
                  <Form.Check
                    type="checkbox"
                    id="checkbox"
                    checked={experience.encoureEper}
                    value={
                      experience.encoureEper != null
                        ? experience.encoureEper
                        : ""
                    }
                    onChange={() => props.onToggleEncoureExperiance(index)}
                    style={{
                      fontSize: "35px",
                      marginTop: "7%",
                      marginLeft: "45%",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6" style={{ marginTop: "15px" }}>
            <span style={{ fontWeight: "900" }}>Titre d'experience</span>
            <input
              type="text"
              className="form-control"
              value={experience.titreProjet}
              onChange={(e) =>
                props.onChangeExperience(index, "titreProjet", e.target.value)
              }
            />
            {experience.titreProjet === "" ? (
              <p style={{ fontSize: "12px", color: "red" }}>
                {props.msgErrExperience}
              </p>
            ) : null}
          </div>

          <div className="col-sm-6" style={{ marginTop: "15px" }}>
            <span style={{ fontWeight: "900" }}>Nom d'entreprise</span>
            <input
              value={experience.nomEntreprise}
              type="text"
              className="form-control"
              onChange={(e) => props.onChangeEntreprise(e, index)}
            />
            {props.searchInputEntreprise.length > 2 &&
            index === props.currentIndex
              ? props.filteredResultsEntreprise.map((item, i) => {
                  return (
                    <option
                      key={i}
                      value={item.nom_entreprise}
                      onClick={(e) => props.selectItemsEntreprise(e, index)}
                    >
                      {item.nom_entreprise}
                    </option>
                  );
                })
              : ""}
            {experience.nomEntreprise === "" ? (
              <p style={{ fontSize: "12px", color: "red" }}>
                {props.msgErrExperience}
              </p>
            ) : null}
          </div>

          <div className="col-sm-12" style={{ marginTop: "15px" }}>
            <textarea
              className="form-control"
              id="form6Example7"
              rows="4"
              cols="54"
              value={
                experience.descriptionExperience != null
                  ? experience.descriptionExperience
                  : ""
              }
              onChange={(e) =>
                props.onChangeExperience(
                  index,
                  "descriptionExperience",
                  e.target.value
                )
              }
              placeholder="Saisire une descrition detaillée de votre experience"
            ></textarea>
          </div>
        </div>
      ))}
    </>
  );
}
